<template>
  <div
    :id="modalId"
    class="modal fade"
    tabindex="-1"
    :aria-labelledby="`${modalId}-label`"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-scrollable modal-fullscreen-sm-down modal-lg"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h2 id="search-tips-modal-label" class="modal-title h3">
            {{ title }}
          </h2>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body text-start w-100">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
<style></style>
<script>
export default {
  props: {
    modalId: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
};
</script>
